import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  DataCollectionApi,
  MaritalStatusRequest,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitMaritalStatus = createAsyncThunk<
  MaritalStatusRequest,
  MaritalStatusRequest,
  ThunkApi
>("submitMaritalStatus", async (args, { rejectWithValue }) => {
  try {
    await new DataCollectionApi().addMaritalStatus(args);
    return args;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Salvataggio stato civile",
      description:
        "Non siamo riusciti a salvare il tuo stato civile.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
